// src/services/AuthService.js
class AuthService {
  constructor() {
    // Determine the correct worker URL based on current environment
    const currentUrl = window.location.hostname;

    if (
      currentUrl.includes("staging") ||
      window.location.search.includes("env=staging")
    ) {
      this.baseURL =
        "https://dcfraud-worker-staging.carpenter-industries-inc.workers.dev";
    } else {
      this.baseURL = "https://dcfraud.dennis-carpenter.com"; // Updated to production URL
    }

    // Standardize the key names
    this.tokenKey = "auth_token";
    this.userKey = "auth_user";
    this.apiKeyKey = "admin_api_key"; // Standardize this name
  }

  async login(username, password) {
    const isSameOrigin = this.baseURL.startsWith(window.location.origin);
    const response = await fetch(`${this.baseURL}/api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: isSameOrigin ? "same-origin" : "include",
      body: JSON.stringify({ username, password }),
    });

    if (!response.ok) {
      throw new Error("Login failed");
    }

    const data = await response.json();

    // Store auth data with consistent key names
    localStorage.setItem(this.tokenKey, data.token);
    localStorage.setItem(this.userKey, JSON.stringify(data.user));
    localStorage.setItem(this.apiKeyKey, data.apiKey);

    // Log API key status after login
    console.log("API key after login:", data.apiKey ? "received" : "missing");

    return data;
  }

  logout() {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
    localStorage.removeItem(this.apiKeyKey);
  }

  getToken() {
    return localStorage.getItem(this.tokenKey);
  }

  // Add logging to getApiKey
  getApiKey() {
    const apiKey = localStorage.getItem(this.apiKeyKey);
    console.log("Retrieved API key:", apiKey ? "exists" : "not found");
    return apiKey;
  }

  // Add this new method to set the API key
  setApiKey(apiKey) {
    console.log("Setting API key in AuthService");
    localStorage.setItem(this.apiKeyKey, apiKey);
    return apiKey;
  }

  // Add this new method to clear the API key
  clearApiKey() {
    console.log("Clearing API key in AuthService");
    localStorage.removeItem(this.apiKeyKey);
  }

  getUser() {
    const user = localStorage.getItem(this.userKey);
    return user ? JSON.parse(user) : null;
  }

  isAuthenticated() {
    return !!this.getToken();
  }

  async validateToken() {
    const token = this.getToken();
    if (!token) return false;

    try {
      const isSameOrigin = this.baseURL.startsWith(window.location.origin);
      const response = await fetch(`${this.baseURL}/api/auth/validate`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        credentials: isSameOrigin ? "same-origin" : "include",
      });
      return response.ok;
    } catch {
      return false;
    }
  }

  // Add this method to validate API key presence
  validateApiKey() {
    const apiKey = this.getApiKey();
    if (!apiKey) {
      console.warn("No API key found - authentication may be incomplete");
      return false;
    }
    return true;
  }
}

const authService = new AuthService();
export default authService;